import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface Props { processor: ProcessorDetails }

const PayUConfigurationCard = ({ processor }: Props) => {
    const options = processor.options as Record<string, any> | null
    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>PayU Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Merchant Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Region</p>
                        <p className="text-sm capitalize">{options?.region ?? 'Global'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Sandbox' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const PayUProcessorDetailsPage = ({ processor }: Props) => (
    <>
        <ProcessorHeader type="payu" processor={processor} />
        <ProcessorOverviewCard processor={processor} />
        <ProcessorMetricsCard processor={processor} />
        <PayUConfigurationCard processor={processor} />
        <ProcessorPaymentMethodsCard processor={processor} />
    </>
)
